'use client';

import { useViewed } from '@/features/viewed';

import { InViewport } from '../InViewport';

interface ViewedProps {
  id: string;
}

export const Viewed = ({ id }: ViewedProps) => {
  const add = useViewed((state) => state.addArticle);

  return <InViewport onInViewport={() => add(id)} isActive={true} />;
};
